import { memo, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

import ProfilePurchasesContainer from '../../containers/profile/ProfilePurchasesContainer'
import Loading from '../Loading'

export default memo(function ProfilePurchasesComponent() {
  const { isAuthenticated, keycloak } = useSelector(state => state.auth)
  const {
    isLoading: isLoadingSubscription,
    oneTimePurchases = []
  } = useSelector(state => state.subscription)

  const navigate = useNavigate()

  useEffect(() => {
    !isAuthenticated && !isEmpty(keycloak) && keycloak.login()
  }, [isAuthenticated, keycloak])

  useEffect(() => {
    document.title = 'Mega GO | Contenido comprado'
    return () => {
      document.title = 'Mega GO'
    }
  }, [])

  return (
    isLoadingSubscription
      ? <Loading />
      : (
        <ProfilePurchasesContainer
          navigate={navigate}
          oneTimePurchases={oneTimePurchases}
        />
      )
  )
})
